// Entry point for the build script in your package.json
import "@hotwired/turbo-rails";
import "./controllers";

import "./application/index.js";

// Fix anchor for turbo
document.addEventListener("turbo:load", function (event) {
  let searchParams = new URL(document.location.toString()).searchParams;
  scrollToElement(searchParams);
});

document.addEventListener("turbo:frame-render", function (event) {
  const searchParams = event.detail.fetchResponse.location.searchParams;
  scrollToElement(searchParams);
});

function scrollToElement(searchParams) {
  if (searchParams.get("anchor_item")) {
    const element = document.getElementById(searchParams.get("anchor_item"));
    if (element) element.scrollIntoView();
  }
}
